import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate, Outlet } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import AuthCallback from "@/pages/AuthCallback";
import Landing from "@/pages/Landing";
import AppShell from "@/components/AppShell";
import LoadFeed from "@/pages/LoadFeed";
import TruckFeed from "@/pages/TruckFeed";
import MyPostings from "@/pages/MyPostings";
import Messages from "@/pages/Messages";
import Subscription from "@/pages/Subscription";
import Admin from "@/pages/Admin";
import ServiceCentres from "@/pages/ServiceCentres";
import Profile from "@/pages/Profile";
import Notifications from "@/pages/Notifications";
import PaymentResult from "@/pages/PaymentResult";
import { Snowflake } from "lucide-react";

function ProtectedRoute() {
  const { auth, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <Snowflake className="w-8 h-8 text-primary animate-spin" />
      </div>
    );
  }
  if (!auth) return <Navigate to="/" replace />;
  return <Outlet />;
}

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/payment/success" element={<PaymentResult />} />
      <Route path="/payment/cancel" element={<PaymentResult />} />
      <Route element={<ProtectedRoute />}>
        <Route path="/app" element={<AppShell />}>
          <Route index element={<LoadFeed />} />
          <Route path="trucks" element={<TruckFeed />} />
          <Route path="repair" element={<ServiceCentres />} />
          <Route path="postings" element={<MyPostings />} />
          <Route path="messages" element={<Messages />} />
          <Route path="messages/:otherId" element={<Messages />} />
          <Route path="notifications" element={<Notifications />} />
          <Route path="subscription" element={<Subscription />} />
          <Route path="profile" element={<Profile />} />
          <Route path="admin" element={<Admin />} />
        </Route>
      </Route>
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ThemeProvider>
          <AuthProvider>
            <AppRouter />
            <Toaster position="top-right" richColors />
          </AuthProvider>
        </ThemeProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
